import type { ReactElement } from 'react';

import { useStats } from 'react-instantsearch';
import styled, { css } from 'styled-components';

import { SkeletonPlaceholder } from '../../shared/common/SkeletonPlaceholder';
import { media } from '../../shared/core/styles';
import { useProductListContext } from '~/utilities/context/static/ProductListContext';
import { useAlgoliaLoadingState } from '~/utilities/hooks/search/useAlgoliaLoadingState';

const S = {
  TotalNumberOfProducts: styled.div`
    ${({ theme }) => css`
      display: inline-flex;
      justify-content: center;
      align-items: center;
      height: 26px;
      margin-inline-start: 0;
      margin-right: ${theme.spacing.x.sm};
      padding-bottom: ${theme.padding.sm};
      color: ${theme.colors.content.secondary};
      font-size: ${theme.font.size[3]};
      font-weight: ${theme.variables.font.weight.regular};
      white-space: nowrap;

      @media ${media(theme).greaterThan('lg')} {
        justify-content: flex-start;
      }
    `}
  `,
};

type TotalNumberOfProductsProps = Readonly<{ className?: string }>;

export const TotalNumberOfProducts = ({ className }: TotalNumberOfProductsProps): ReactElement => {
  const { systemTexts } = useProductListContext();
  const { nbHits } = useStats();
  const { isFirstLoading } = useAlgoliaLoadingState();

  return (
    <S.TotalNumberOfProducts className={className} data-testid="total-number-products">
      {isFirstLoading ? (
        <SkeletonPlaceholder width="80px" height="26px" />
      ) : (
        <>
          {nbHits} {systemTexts?.totalNumberOfProducts?.label ?? ''}
        </>
      )}
    </S.TotalNumberOfProducts>
  );
};
